module.exports = __webpack_public_path__ + "static/media/Mark-No-Show-Icon.33bfb711.svg";